import { Box } from '@fhs-legacy/universal-components';

const HEADER_SPACING = '11rem';

export const MapContainer = Box.withConfig({
  height: 'full',
  _web: {
    height: {
      base: `calc(100dvh - ${HEADER_SPACING})`,
      desktop: '600px',
    },
  },
});
